// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a93c7a9f","977":"d9471526"}[chunkId] + ".chunk.js";
};